import { Box, Image, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useState } from 'react'
import Button, { ButtonP } from '../../../comps/Button'
import ContactUs from '../../../comps/ContactUs'
import { Modal, ModalTypes } from '../../../comps/ModalWeb'
import Navbar from '../../../comps/Nav'
import NavMob from '../../../comps/NavMobile'
import useFontSize from '../../../util/useFontSize'
import usePadding from '../../../util/usePadding'
import { isDesktopWidth, isMobileWidth, isTabletWidth, useWindowDimensions } from '../../../util/util'
import CheckList from './checkList'
import { sectionData } from './data'
import SectionList from './sectionList'
import { styles } from './styles'

interface WhyJioProps {
  id: any
}

const WhyJioSection: FC<WhyJioProps> = ({ id }: WhyJioProps) => {
  const { headerSize, subHeaderSize, subHeaderLineHeight, headerLineHeight } = useFontSize()
  const [navVisible, setNavVisible] = useState(false)
  const navigate = useNavigation().navigate

  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const viewPortWidth = useWindowDimensions()

  const handleLeftPress = () => {
    navigate('contact')
  }

  const handleRightPress = () => {
    navigate('direct')
  }

  const responsivePadding = usePadding()
  const themedStyle = styles(viewPortWidth, responsivePadding)
  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const isDesktop = isDesktopWidth(viewPortWidth)
  return (
    <>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar onPress={handleNav} isLightBackground={true} />
      <Box {...themedStyle.outerontainer}>
        <Box {...themedStyle.container}>
          <Box {...themedStyle.leftBox}>
            <Box w={isMobile || isTab ? '90%' : undefined}>
              <Text
                fontSize={headerSize}
                lineHeight={isMobile || isTab ? headerLineHeight + 4 : headerLineHeight}
                fontFamily="jiotype-black">
                {sectionData[id]?.header}
              </Text>
            </Box>
            <Spacer size={isMobile || isTab ? 18 : 'HUGE'} />
            <Text fontSize={subHeaderSize} lineHeight={subHeaderLineHeight} fontFamily="jiotype-bold">
              {sectionData[id]?.subHeader}
            </Text>
            <Spacer size={isMobile || isTab ? 6 : 'HUGE'} />
            <CheckList data={sectionData[id]?.checkList} isMobile={isMobile} isTab={isTab} />
            <Spacer size={isMobile || isTab ? 24 : 'HUGE'} />
            <Box {...themedStyle.buttonContainer}>
              {sectionData[id]?.buttonLeft && (
                <ButtonP
                  width={isMobile ? '47%' : isTab ? '46%' : undefined}
                  color={'BLUE_SHADE'}
                  title={sectionData[id]?.buttonLeft?.title}
                  onPress={handleLeftPress}
                />
              )}
              <Spacer size={isTab ? 24 : isMobile ? 0 : 'MEDIUM'} direction="horizontal" />
              {sectionData[id]?.buttonRight && (
                <Button
                  width={isMobile ? '47%' : isTab ? '46%' : undefined}
                  color="BLUE_SHADE"
                  title={sectionData[id]?.buttonRight?.title}
                  onPress={handleRightPress}
                />
              )}
            </Box>
          </Box>
          <Box {...themedStyle.imageContainer}>
            <Image
              source={sectionData[id]?.lpImage}
              height={isTab || isMobile ? 245 : 500}
              width={isTab || isMobile ? 245 : 530}
              resizeMode="contain"
            />
          </Box>
        </Box>
        <SectionList data={sectionData[id]?.contentMap} />
        <Spacer size={isMobile ? 140 : isDesktop ? 140 : undefined} />
        <ContactUs type={'footer'} />
      </Box>
    </>
  )
}

export default WhyJioSection
